export const FIELD_ID = {
  casePlaintiff: {
    worker: 19316,
    namedPlaintiff: 19317,
    derivativePlaintiff: 19318,
  },
}
